import M from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import Api from "../../../../../Services/Api";
import { mapToObjectDDL } from "../../../../common/mapper";
import { INITIAL_FILTER_DATA } from "../config";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";

class ReceivingGiftFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLocator: [],
      dataCategory: [],
      filterData: INITIAL_FILTER_DATA,
    };
  }

  componentDidMount = async () => {
    this.loadInitialData();
  };

  handleSubmit = () => {
    this.props.onSubmit(this.state.filterData);
  };

  loadInitialData = async () => {
    const { onTriggerLoading, filteredData, setError, selectedCabang } =
      this.props;

    onTriggerLoading();

    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllHadiah,
        menuName: "Receiving Gift",
        setError,
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA")
          .getAllMasterLocationPagingByParam,
        menuName: "Receiving Gift",
        setError,
        args: {
          paramFilters: { kodeCabang: selectedCabang?.value },
        },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
        menuName: "Receiving Gift",
        setError,
        args: { paramFilters: { bizparCategory: "GIFT_TYPE" } },
      }),
    ];
    
    const [resHadiah, resLocator, resCategory] = await Promise.all(promises);
    onTriggerLoading()

    // handle dataHadiah
    if (resHadiah.ok && resHadiah.data.status === HttpStatus.SUCCESS) {
      const hadiahData =
        resHadiah.data.data?.map((item) => ({
          label: item.kodeHadiah,
          value: item.kodeHadiah,
          ...item,
        })) ?? [];
      this.setState({ dataHadiah: hadiahData });
    }

    // handle dataLocator
    if (resLocator.ok && resLocator.data.status === HttpStatus.SUCCESS) {
      const locatorData =
        resLocator.data.data?.map((item) =>
          mapToObjectDDL(item.nameLocation, item.kodeLocation)
        ) ?? [];
      this.setState({ dataLocator: locatorData });
    }

    // handle dataCategory
    if (resCategory.ok && resCategory.data.status === HttpStatus.SUCCESS) {
      const categoryData =
        resCategory.data.data?.map((item) => ({
          label: item.value,
          value: item.key,
        })) ?? [];
      this.setState({ dataCategory: categoryData });
    }

    // handle filtered data (edit mode)
    if (filteredData) {
      const hadiah = resHadiah.data.data?.find(
        (item) => item.kodeHadiah === filteredData?.giftCode
      );
      const kategori = resCategory.data.data?.find(
        (item) => item.key === filteredData?.giftCategory
      );
      const locator = resLocator.data.data?.find(
        (item) => item.kodeLocation === filteredData?.idLocator
      );

      this.setState({
        filterData: {
          ...filteredData,
          giftCode: hadiah
            ? {
                label: hadiah.kodeHadiah,
                value: hadiah.kodeHadiah,
                ...hadiah,
              }
            : null,
          giftCategory: kategori
            ? {
                label: kategori.value,
                value: kategori.key,
              }
            : null,
          idLocator: locator
            ? mapToObjectDDL(locator.nameLocation, locator.kodeLocation)
            : null,
        },
      });
    }
  };

  handleValueChange = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      filterData: {
        ...prev.filterData,
        [name]: value,
      },
    }));
  };

  handleClearFilter = () => {
    this.setState({
      filterData: INITIAL_FILTER_DATA,
    });
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { dataCategory, dataLocator, filterData, dataHadiah } = this.state;
    return (
      <SimpleModal
        title="Filter Search"
        visible={visible}
        onClickClose={onClickClose}
        content={
          <React.Fragment>
            <ModalContainer>
              <FlexView column>
                <FlexView column vAlignContent="center">
                  <p>Tanggal SPBH</p>
                  <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                    <SimpleDate
                      date={filterData.spbhStartDate}
                      onChange={(value) =>
                        this.handleValueChange(
                          "spbhStartDate",
                          M(value).format("DD-MM-YYYY")
                        )
                      }
                    />
                    <span className="margin-bottom-20px">To</span>
                    <SimpleDate
                      date={filterData.spbhEndDate}
                      onChange={(value) =>
                        this.handleValueChange(
                          "spbhEndDate",
                          M(value).format("DD-MM-YYYY")
                        )
                      }
                    />
                  </FlexView>
                </FlexView>
                <SimpleInput
                  name="spbhNo"
                  label="No. SPBH"
                  value={filterData.spbhNo}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value?.trim())
                  }
                />

                <FlexView column>
                  <p>Tanggal SPBM:</p>
                  <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                    <SimpleDate
                      date={filterData.spbmStartDate}
                      onChange={(value) =>
                        this.handleValueChange(
                          "spbmStartDate",
                          M(value).format("DD-MM-YYYY")
                        )
                      }
                    />
                    <span className="margin-bottom-20px">To</span>
                    <SimpleDate
                      date={filterData.spbmEndDate}
                      onChange={(value) =>
                        this.handleValueChange(
                          "spbmEndDate",
                          M(value).format("DD-MM-YYYY")
                        )
                      }
                    />
                  </FlexView>
                </FlexView>
                <SimpleInput
                  name="spbmNo"
                  label="No. SPBM"
                  value={filterData.spbmNo}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value?.trim())
                  }
                />
                <h3>Filter Detail</h3>
                <SimpleDDL
                  id={`select_options_kodehadiah`}
                  box="search"
                  label="Kode Hadiah"
                  name="giftCode"
                  isClearable={true}
                  options={dataHadiah}
                  value={filterData.giftCode}
                  onChange={(value, { name }) =>
                    this.handleValueChange(name, value)
                  }
                />
                <SimpleDDL
                  id={`select_options_kategorihadiah`}
                  box="search"
                  label="Kategori Hadiah"
                  name="giftCategory"
                  isClearable={true}
                  options={dataCategory}
                  value={filterData.giftCategory}
                  onChange={(value, { name }) =>
                    this.handleValueChange(name, value)
                  }
                />
                <SimpleDDL
                  id="select_options_locator"
                  box="search"
                  label="Locator"
                  name="idLocator"
                  isClearable={true}
                  options={dataLocator}
                  value={filterData.idLocator}
                  onChange={(value, { name }) =>
                    this.handleValueChange(name, value)
                  }
                />
              </FlexView>
              <FlexView hAlignContent="right" style={{ gap: "10px" }}>
                <SimpleButton type="button" onClick={this.handleClearFilter}>
                  Clear
                </SimpleButton>
                <SimpleButton onClick={this.handleSubmit}>
                  Terapkan
                </SimpleButton>
              </FlexView>

              <SimpleLoadingOverlay active={this.state.loading} />
            </ModalContainer>
          </React.Fragment>
        }
      />
    );
  }
}

export default ReceivingGiftFilter;
